import { FC } from 'react';
import TasksTable from '../../parts/TasksTable';

const DashboardPage: FC = () => <TasksTable />;

export default DashboardPage;
